import React, { useState } from 'react';
import { apiService } from '../../services/api';
import { useMutation } from '../../hooks/useApi';
import logger from '../../utils/logger';
import { useSettings } from '../../context/SettingsContext';
import { BarChart, Wallet, ShoppingCart, DollarSign, FileDown, Eye } from 'lucide-react';

function RaportFitimi() {
  const { getCurrencyCode } = useSettings();
  const currencyCode = getCurrencyCode();
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  const { execute: fetchRaport, loading: loadingRaport } = useMutation(
    async ({ from, to }) => {
      return await apiService.get('/raport-fitimi', { params: { from, to } });
    },
    {
      showNotifications: false
    }
  );

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setData(null);
    try {
      const data = await fetchRaport({ from, to });
      setData(data);
      setError('');
    } catch (err) {
      setError('Nuk mund të merret raporti.');
    }
  };

  const handleExportPdf = async () => {
    if (!from || !to) {
      setError('Ju lutem zgjidhni datat për PDF.');
      return;
    }

    try {
      const response = await apiService.get('/raport-fitimi/pdf', {
        params: { from, to },
        responseType: 'blob'
      });

      const file = new Blob([response], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
    } catch (err) {
      logger.error('PDF export error:', err);
      setError('Dështoi shkarkimi i PDF-it.');
    }
  };

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold flex items-center gap-2 text-gray-800 dark:text-gray-100">
        <BarChart size={24} /> Raporti i Fitimit
      </h2>

      <form onSubmit={handleSubmit} className="card-premium p-6 grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label className="form-label">Nga data</label>
          <input
            type="date"
            value={from}
            onChange={(e) => setFrom(e.target.value)}
            className="input-premium"
            required
          />
        </div>
        <div>
          <label className="form-label">Deri më</label>
          <input
            type="date"
            value={to}
            onChange={(e) => setTo(e.target.value)}
            className="input-premium"
            required
          />
        </div>
        <button
          type="submit"
          className="btn-premium mt-auto flex items-center justify-center gap-2"
        >
          <Eye size={18} /> Shfaq
        </button>
      </form>

      {error && <p className="p-3 rounded-lg bg-red-100 text-red-700 dark:bg-red-900/20 dark:text-red-300 font-medium">{error}</p>}

      {data && (
        <div className="space-y-6 mt-4">
          <button
            onClick={handleExportPdf}
            className="btn-premium flex items-center gap-2"
          >
            <FileDown size={18} /> Shkarko PDF
          </button>

          {data?.lokacionet?.map((l, i) => (
  <div key={i} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
    <div className="col-span-full font-semibold text-gray-700 dark:text-gray-300">{l.lokacion}</div>
    <div className="card-premium p-4 border-l-4 border-secondary-500 dark:border-secondary-400">
      <span className="text-secondary-700 dark:text-secondary-400 font-medium">Shitje</span>
      <p className="text-lg font-semibold text-gray-800 dark:text-gray-100">{l.shitje_totale.toFixed(2)} {currencyCode}</p>
    </div>
    <div className="card-premium p-4 border-l-4 border-yellow-500 dark:border-yellow-400">
      <span className="text-yellow-700 dark:text-yellow-400 font-medium">Blerje</span>
      <p className="text-lg font-semibold text-gray-800 dark:text-gray-100">{l.blerje_totale.toFixed(2)} {currencyCode}</p>
    </div>
    <div className="card-premium p-4 border-l-4 border-red-500 dark:border-red-400">
      <span className="text-red-700 dark:text-red-400 font-medium">Harxhime</span>
      <p className="text-lg font-semibold text-gray-800 dark:text-gray-100">{l.harxhime_totale.toFixed(2)} {currencyCode}</p>
    </div>
    <div className="card-premium p-4 border-l-4 border-green-500 dark:border-green-400">
      <span className="text-green-700 dark:text-green-400 font-medium">Fitimi Neto</span>
      <p className="text-xl font-bold text-gray-800 dark:text-gray-100">{l.fitim_neto.toFixed(2)} {currencyCode}</p>
    </div>
  </div>
))}

{/* Totali përgjithshëm */}
<div className="card-premium p-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
  <div className="text-secondary-700 dark:text-secondary-400 font-semibold">Shitje Totale: <span className="text-gray-800 dark:text-gray-100">{data.totali.shitje_totale.toFixed(2)} {currencyCode}</span></div>
  <div className="text-yellow-700 dark:text-yellow-400 font-semibold">Blerje Totale: <span className="text-gray-800 dark:text-gray-100">{data.totali.blerje_totale.toFixed(2)} {currencyCode}</span></div>
  <div className="text-red-700 dark:text-red-400 font-semibold">Harxhime Totale: <span className="text-gray-800 dark:text-gray-100">{data.totali.harxhime_totale.toFixed(2)} {currencyCode}</span></div>
  <div className="text-green-700 dark:text-green-400 font-semibold text-lg">Fitim Neto: <span className="text-gray-800 dark:text-gray-100">{data.totali.fitim_neto.toFixed(2)} {currencyCode}</span></div>
</div>
</div>
      )}
    </div>
  );
}

export default RaportFitimi;
